/**
 * Textos e padrões usados para identificar campos do questionário
 * (pré-preenchimento, cálculo de IMC, ocultação e validação).
 */

export const FIELD_TEXT_PATTERNS = {
  nome: ["nome", "name"],
  idade: ["idade", "age"],
  peso: ["peso", "weight"],
  altura: ["altura", "height"],
  imc: ["imc", "bmi", "índice de massa"],
  sexo: ["sexo", "gender", "gênero", "genero"],
  dataNascimento: ["data de nascimento", "birth date", "nascimento"],
} as const;

export const HIDDEN_FIELD_PATTERNS = [
  ...FIELD_TEXT_PATTERNS.nome,
  ...FIELD_TEXT_PATTERNS.idade,
  ...FIELD_TEXT_PATTERNS.sexo,
];

export const HIDDEN_DATE_PATTERNS = ["data", "nascimento", "birth"];

export const VALIDATION_MESSAGES = {
  required: "Este campo é obrigatório",
  maxLength: (max: number) => `Máximo de ${max} caracteres`,
  integer: "Digite um número inteiro",
  decimal: "Digite um número válido",
} as const;
